export const getProfileCoowner_mobile = profile => profile?.properties?.coowner_mobile
export const getProfileCoowner_email = profile => profile?.properties?.coowner_email
export const getProfileCoowner_firstname = profile => profile?.properties?.coowner_firstname
export const getProfileCoowner_lastname = profile => profile?.properties?.coowner_lastname
export const getProfileCoowner_patronymic = profile => profile?.properties?.coowner_patronymic
export const getProfileFacebook = profile => profile?.properties?.facebook
export const getProfileVk = profile => profile?.properties?.vk
export const getProfileOk = profile => profile?.properties?.ok
export const getProfileTelegram = profile => profile?.properties?.telegram
export const getProfileWatsapp = profile => profile?.properties?.watsapp
export const getProfileInstagram = profile => profile?.properties?.instagram
export const getProfileYoutube = profile => profile?.properties?.youtube
export const getProfileTiktok = profile => profile?.properties?.tiktok
export const getProfileViber = profile => profile?.properties?.viber
export const getProfileTwitter = profile => profile?.properties?.twitter

